import React, { } from "react"
import { View, Text, Keyboard } from "react-native"
import { View as AnimatableView } from "react-native-animatable"

import { PrimaryCTA } from "../CommonCTA"

import { IndiaRupee } from "../../constants/AppConstants"

import AppStyles from "../../../AppStyles"
import TextStyle from "../../../TextStyle"
import AppTheme from "../../../AppTheme"

export const EstimatedPriceView = (props) => {
    const ctaTitle = props.ctaTitle
    const ctaAction = props.ctaAction
    const isCtaDisabled = props.isCtaDisabled
    const cartTotalAmount = props?.cartTotalAmount
    const viewStyle = props?.viewStyle ?? null
    function getCartAmount() {
        return cartTotalAmount ? cartTotalAmount.toFixed(2) : ' ---'
    }
    return (<AnimatableView key={'CartEstimatedPriceView'}
        animation="fadeInUp" style={[AppStyles.appWidth,
        AppStyles.bottomFix, AppStyles.flexRowSpaceBetween,
        AppStyles.bgWhite, AppStyles.px16, AppStyles.py6, viewStyle]}
        duration={AppTheme.transitionDuration} delay={AppTheme.transitionDuration}>
        <View>
            <Text style={TextStyle.text18xb}>
                {IndiaRupee}{getCartAmount()}</Text>
            <Text style={[TextStyle.text12, TextStyle.colorGrey]}>
                Estimated Price</Text>
        </View>
        <PrimaryCTA width={132} title={ctaTitle}
            disabled={isCtaDisabled} action={() => {
                ctaAction(); Keyboard.dismiss()
            }} />
    </AnimatableView>
    )
}